import { Box, Paper, TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useCallback } from 'react';
import { PaymentForm } from '../../interfaces/Checkout/PaymentForm';
import { validateProfile } from './utils';

type ProfileFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  errorMessage?: string;
};

const ProfileField = ({
  label,
  value,
  onChange,
  errorMessage,
}: ProfileFieldProps) => {
  const itemSize = {
    xs: 12,
    md: 6,
  };

  return (
    <Grid size={itemSize}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 0.5,
          width: '100%',
        }}
      >
        <Typography>{label}</Typography>

        <TextField
          size='small'
          fullWidth
          value={value}
          onChange={(e) => onChange(e.target.value)}
          error={!!errorMessage}
          helperText={errorMessage}
        />
      </Box>
    </Grid>
  );
};

type CheckoutProfileProps = {
  form: PaymentForm;
  onChange: (form: PaymentForm) => void;
};

export const CheckoutProfile = ({ form, onChange }: CheckoutProfileProps) => {
  const errors = validateProfile(form);

  const handleChange = useCallback(
    (field: keyof PaymentForm, value: string) => {
      onChange({
        ...form,
        [field]: value,
      });
    },
    [form],
  );

  return (
    <>
      <Paper
        elevation={3}
        sx={{
          px: 2.5,
          py: 2,
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          width: '100%',
        }}
      >
        <Grid container spacing={2} width='100%'>
          <ProfileField
            label='İsim'
            value={form.firstName}
            onChange={(x) => handleChange('firstName', x)}
            errorMessage={errors.firstName}
          />

          <ProfileField
            label='Soyisim'
            value={form.lastName}
            onChange={(x) => handleChange('lastName', x)}
            errorMessage={errors.lastName}
          />

          <ProfileField
            label='E-Posta'
            value={form.email}
            onChange={(x) => handleChange('email', x)}
            errorMessage={errors.email}
          />

          <ProfileField
            label='Telefon'
            value={form.phone}
            onChange={(x) => handleChange('phone', x)}
            errorMessage={errors.phone}
          />
        </Grid>
      </Paper>

      <Paper
        elevation={3}
        sx={{
          px: 2.5,
          py: 2,
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          width: '100%',
        }}
      >
        <Typography sx={{ fontWeight: 600 }}>Sipariş Notu</Typography>

        <TextField
          size='small'
          minRows={2}
          multiline
          value={form.notes}
          onChange={(e) => handleChange('notes', e.target.value)}
        />
      </Paper>
    </>
  );
};
